// extracted by mini-css-extract-plugin
module.exports = {"teamContainer":"my-team_teamContainer__xbOMY","team":"my-team_team__3v30z"};